import React from 'react';
import Sidebar from '../components/Sidebar';
import PaymentsContent from '../components/PaymentsContent';

const Payments = ({ onLogout }) => {
  return (
    <div className='d-flex w-100 overflow-hidden'>
      <div className='asidebar'>
        <Sidebar onLogout={onLogout} />
      </div>
      <div className='main-content'>
        <PaymentsContent />
      </div>
    </div>
  );
};

export default Payments;
